<template>
  <ArtworksPreview
    :selectedArtworks="selectedArtworks"
    :allArtworks="allArtworks"
    @change="($e) => $emit('change', $e)"
    isSelectable
  />
</template>
<script>
export default {
  name: 'SendPurchaseOrderArtworks',
  components: {
    ArtworksPreview: () => import('./components/Artwork/ArtworksPreview')
  },
  props: {
    allArtworks: Array,
    selectedArtworks: Object,
    purchaseOrder: Object
  }
};
</script>
